import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiCheck, FiFileText, FiDownload, FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import Ir21SearchModal from "../../../Ir21/Search/Ir21SearchModal";
import Ir21TemplateModal from "../../../../../components/Ir21/Ir21TemplateModal";
import { ErrorUnexpected } from "../../../../../const/Messages";
import * as Ir21Service from "../../../../../service/Ir21Service";
import * as PlmnService from "../../../../../service/PlmnService";

/**
  @author Thiago Dias
  @date 27/05/2026
 */
export default function ManagementTadigList() {
  const [isLoading, setIsLoading] = useState(true);
  const [plmn, setPlmn] = useState([]);
  const [ir21DataModal, setIr21DataModal] = useState({
    isOpen: false,
    plmnId: 0,
  });

  const [showModal, setShowModal] = useState(false);
  const [organisationId, setOrganisationId] = useState("");
  const [organisationName, setOrganisationName] = useState("");

  useEffect(updateData, []);

  function updateData() {
    setIsLoading(true);
    PlmnService.findAll()
      .then((plmnList) => {
        setPlmn(
          plmnList.sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            return 0;
          })
        );
      })
      .catch(() => {
        toast.error(ErrorUnexpected);
      })
      .finally(() => setIsLoading(false));
  }

  function handleDownload(organisationId, organisationName) {
    setShowModal(true);
    setOrganisationId(organisationId);
    setOrganisationName(organisationName);
  }

  function handleOpen(plmnId) {
    setIr21DataModal({ isOpen: true, plmnId });
  }

  function handleClose() {
    setIr21DataModal({ ...ir21DataModal, isOpen: false });
  }

  function exportALL() {
    setIsLoading(true);
    Ir21Service.getExportDataAll()
      .catch(() => {
        toast.error(ErrorUnexpected);
      })
      .finally(() => setIsLoading(false));
  }

  const [columns] = useState([
    {
      title: "TADIG",
      field: "name",
    },
    {
      title: "NUMBER",
      field: "number",
    },
    {
      title: "MGT",
      field: "e214",
    },
    {
      title: "ORGANISATION",
      field: "organisation.name",
    },
    {
      title: "COUNTRY",
      field: "country.name",
    },
    {
      title: "NNGT Max Removable Digits",
      field: "nngtMaxRemovableDigits",
    },
    {
      title: "IR.21",
      field: "hasIr21",
      render: (obj) =>
        obj.hasIr21 ? <FiCheck color="green" /> : <FiX color="red" />,
      customSort: (obj1, obj2) => obj1.hasIr21 - obj2.hasIr21,
      width: "1%",
      lookup: { true: "Found", false: "Not Found" },
    },
  ]);

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title d-flex justify-content-between">
            <h5>Tadig - List</h5>
          </div>
          <div className="ibox-content">
            <MaterialTable
              title=""
              columns={columns}
              data={plmn}
              isLoading={isLoading}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                rowStyle: {
                  fontSize: 13,
                },
                pageSize: 10,
                pageSizeOptions: [5, 10, 15, 20],
                actionsColumnIndex: -1,
                exportButton: true,
                exportAllData: true,
                searchFieldAlignment: "left",
                toolbarButtonAlignment: "right",
                exportFileName: "tadig",
                filtering: true,
                headerStyle: {
                  textTransform: "uppercase",
                },
              }}
              actions={[
                {
                  icon: () => <FiFileText size={21} color="#676a6c" />,
                  tooltip: "Export IR.21",
                  isFreeAction: true,
                  onClick: () => exportALL(),
                },
                {
                  icon: () => <FiFileText size={16} color="#007bff" />,
                  tooltip: "VIEW IR.21 DATA",
                  onClick: (_, rowData) => handleOpen(rowData.id),
                },
                {
                  icon: () => <FiDownload size={16} color="#007bff" />,
                  tooltip: "Download",
                  onClick: (_, rowData) =>
                    handleDownload(
                      rowData.organisation?.id,
                      rowData.organisation?.name
                    ),
                },
              ]}
            />
          </div>
        </div>
        <Ir21TemplateModal
          modalData={ir21DataModal}
          handleClose={handleClose}
        />
        <Ir21SearchModal
          setShowModal={setShowModal}
          showModal={showModal}
          organisationId={organisationId}
          organisationName={organisationName}
        />
      </Col>
    </Row>
  );
}
